import { getPreferredPhone, useGetAllContacts, useGetContact } from "@api/contactService";
import React, { useContext, useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ObjectShow from "@components/objects/ObjectShow";
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import ObjectColumn from "@components/objects/ObjectColumn";
import { ObjectPrimaryInfo } from "@components/objects/ObjectPrimaryInfo";
import { ObjectRelationship } from "@components/objects/ObjectRelationship";
import Avatar from "@mui/joy/Avatar";
import { ObjectContext } from "@providers/ObjectProvider";
import { ensureDateObject, formatAbsoluteDate, formatDate, isValidDate } from "@utils/dates";
import ObjectPreview from "@components/objects/ObjectPreview";
import { generateAddress } from "@utils/generateAddress";
import { CardOverflow, List, ListDivider, ListItem, ListItemContent, ListItemDecorator, Table } from "@mui/joy";
import AbstractObjectRelationship from "@components/objects/AbstractObjectRelationship";
import UserAccessCard from "@components/objects/UserAccessCard";
import { intervalToDuration } from "date-fns";
import { useGetEvent } from "@api/eventService";

/*
interface ShowData {
    label?: string;
    conditional?: Function|boolean;
    content?: Function|string;
};
*/

const CardHeader = () => {
    const data = useContext(ObjectContext);
    const avatarInitials = data.name ? data.name.split(' ').map(i => i.charAt(0)).join('').toUpperCase() : '';

    return (
    <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        p={1.5}
        pt={0}
    >
        <Box sx={{flex: 1}}>
            <Typography fontSize={'md'} fontWeight={'bold'}>{data.name}</Typography>
            {data.location && <Typography fontSize={'sm'}>{data.location}</Typography>}
        </Box>
    </Stack>
)
};

const dataToDisplay/*: readonly ShowData[]*/ = [
    {
        label: 'Category',
        conditional: object => !!object.event_category_id,
        content: (object) => object.category?.name,
    },
    {
        label: 'Location',
        conditional: object => !!object.location,
        content: 'location',
    },
    {
        label: 'Attendance',
        conditional: object => !!object.attendance,
        content: 'attendance',
    },
    {
        label: 'Summary',
        conditional: object => !!object.summary,
        content: 'summary',
    },
    {
        label: <>Volunteer<br/>Opportunities</>,
        conditional: object => !!object.opportunities.length,
        content: (object) => <>
            {object.opportunities.map((opportunity, opportunityIndex) => (<React.Fragment key={opportunityIndex}>
                <ObjectPreview to={`/opportunities/${opportunity.id}`} object={opportunity}>{opportunity.name}</ObjectPreview>
                <br/>
            </React.Fragment>))}
        </>
    },
];

export default function EventShow() {
    return (
        <ObjectShow
            query={useGetEvent}
            type={'event'}
            permissionType={'events'}
            title={'Events'}
            subtitleKey={'name'}
            color={'event'}
        >
            <ObjectColumn primary>
                <ObjectPrimaryInfo
                    title={'Event Info'}
                    tint={'event'}
                    fields={dataToDisplay}
                    cardHeader={<CardHeader/>}
                />
                <ObjectRelationship type={'notes'} column={'description'} title={'Description'} />
            </ObjectColumn>

            <ObjectColumn>
                <ObjectRelationship type={'dates'} />
            </ObjectColumn>

            <ObjectColumn>
                <ObjectRelationship type={'workplans'} />
                <ObjectRelationship type={'files'} />
            </ObjectColumn>
        </ObjectShow>
    )
}
